import { initializeApp, FirebaseApp } from 'firebase/app';
import { getMessaging, Messaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDVc0l5qkQjB9_c9B2FQ9xDT7ZeOSKJLHU",
  authDomain: "alfakhamah-8337d.firebaseapp.com",
  projectId: "alfakhamah-8337d",
  storageBucket: "alfakhamah-8337d.firebasestorage.app",
  messagingSenderId: "801202709547",
  appId: "1:801202709547:web:46ca4ab74390b8b890366e",
  measurementId: "G-FNQREVHVSF"
};

let app: FirebaseApp | null = null;
let messaging: Messaging | null = null;

/**
 * Initialize Firebase app
 */
export function initializeFirebase(): FirebaseApp {
  if (!app) {
    app = initializeApp(firebaseConfig);
  }
  return app;
}

/**
 * Get Firebase Messaging instance
 * Returns null if not supported (e.g., in non-secure contexts)
 */
export function getFirebaseMessaging(): Messaging | null {
  try {
    if (!messaging) {
      const firebaseApp = initializeFirebase();
      messaging = getMessaging(firebaseApp);
    }
    return messaging;
  } catch (error) {
    console.error('Firebase Messaging not supported:', error);
    return null;
  }
}

export { app, messaging };

